import { CartAddEvent } from '@theme/events';

/* Dates de livraison estimées (8 à 15 jours ouvrés) */
function addBusinessDays(d, n) { const r = new Date(d); let a = 0; while (a < n) { r.setDate(r.getDate() + 1); const w = r.getDay(); if (w !== 0 && w !== 6) a++; } return r; }
function fmt(d) { return d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'long' }).replace('.', ''); }
function fillDates(root = document) {
  root.querySelectorAll('[data-shx-dates]:not([data-done])').forEach((el) => {
    el.dataset.done = '1';
    const now = new Date();
    el.textContent = `entre le ${fmt(addBusinessDays(now, 8))} et le ${fmt(addBusinessDays(now, 15))}`;
  });
}
fillDates();

/* Ajout rapide depuis les cartes produit */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-shx-quick-add]');
  if (!btn) return;
  e.preventDefault();
  if (btn.disabled) return;
  btn.disabled = true;
  btn.classList.add('is-loading');
  try {
    const sections = [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
    const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }], sections: sections.join(','), sections_url: location.pathname }),
    });
    const data = await res.json();
    if (data.status) throw new Error(data.description || data.message);
    const cart = await (await fetch('/cart.js')).json();
    document.dispatchEvent(new CartAddEvent(cart, 'shx-quick-add', { source: 'shx-quick-add', itemCount: cart.item_count, variantId: String(btn.dataset.variantId), productId: btn.dataset.productId, sections: data.sections }));
    btn.classList.add('is-added');
    btn.querySelector('span').textContent = 'Ajouté au panier';
    document.querySelector('cart-drawer-component')?.open?.();
    setTimeout(() => { btn.classList.remove('is-added'); btn.querySelector('span').textContent = 'Ajout rapide'; }, 2500);
  } catch (err) {
    console.error(err);
    window.location.href = btn.dataset.url;
  } finally {
    btn.disabled = false;
    btn.classList.remove('is-loading');
  }
});

/* Réassurance dans le tiroir panier */
function injectCartExtras() {
  const tpl = document.getElementById('shx-cx-tpl');
  if (!tpl) return;
  document.querySelectorAll('.cart-drawer__summary').forEach((sum) => {
    if (sum.querySelector('.shx-cx')) return;
    sum.appendChild(tpl.content.cloneNode(true));
    fillDates(sum);
  });
}
injectCartExtras();
let shxT;
new MutationObserver(() => { clearTimeout(shxT); shxT = setTimeout(() => { injectCartExtras(); fillDates(); }, 60); }).observe(document.body, { childList: true, subtree: true });

/* Ouvre le tiroir panier après tout ajout (bouton principal, barre collante) */
document.addEventListener(CartAddEvent.eventName || 'cart:update', (e) => {
  if (e.detail?.data?.source === 'shx-quick-add') return;
  if (e.detail?.data?.didError) return;
  if (/\/cart\/?$/.test(location.pathname)) return;
  setTimeout(() => {
    const d = document.querySelector('cart-drawer-component');
    if (d && !d.hasAttribute('open') && !d.querySelector('dialog[open]')) d.open?.();
  }, 350);
});

/* Choix de la couleur sur les cartes produit (met à jour l'image, le lien et l'ajout rapide) */
document.addEventListener('click', (e) => {
  const sw = e.target.closest('[data-shx-swatch]');
  if (!sw) return;
  e.preventDefault();
  const card = sw.closest('.shx-pcard');
  if (!card) return;
  card.querySelectorAll('[data-shx-swatch]').forEach((d) => { const on = d === sw; d.classList.toggle('is-on', on); d.setAttribute('aria-pressed', on ? 'true' : 'false'); });
  const vid = sw.dataset.variantId;
  const ok = sw.dataset.available === 'true';
  const q = card.querySelector('[data-shx-quick-add]');
  if (q) {
    q.dataset.variantId = vid;
    q.disabled = !ok;
    const t = q.querySelector('span');
    if (t) t.textContent = ok ? 'Ajout rapide' : 'Épuisé';
    q.setAttribute('aria-label', `Ajout rapide au panier : ${card.querySelector('.shx-pcard__title')?.textContent.trim() || ''} – ${sw.title}`);
  }
  const img = card.querySelector('.shx-pcard__media img');
  if (img && sw.dataset.img) { img.removeAttribute('srcset'); img.src = sw.dataset.img; img.alt = `${card.querySelector('.shx-pcard__title')?.textContent.trim() || ''} – ${sw.title}`; }
  card.querySelectorAll('a[href*="/products/"]').forEach((a) => { const u = new URL(a.getAttribute('href'), location.origin); u.searchParams.set('variant', vid); a.setAttribute('href', u.pathname + u.search); });
});
